import { defineComponent as _defineComponent } from 'vue'
import { ThumborOptions } from '@/filters/thumbor';
import Vue, { computed } from 'vue';
import WatchNowButton from '@/components/buttons/WatchNowButton.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';
import { useI18n } from '@/helpers/composables/useI18n';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { Viewport } from '@/enums/viewport';
import type { Top10ModuleInYourCountry } from '@/features/onboarded-home/types';

type TitleType = Top10ModuleInYourCountry['titles'][number];

export default /*#__PURE__*/_defineComponent({
  __name: 'TitlesHero',
  props: {
    title: null,
    additionalContexts: null
  },
  emits: ["titleClicked"],
  setup(__props: any) {

const props = __props as {
	title: TitleType;
	additionalContexts: SnowplowContext[];
};





const { tc } = useI18n();
const languageStore = useLanguageStore();
useProvideClickoutPlacement('home_top_free_title');

const countryName = computed(() => {
	return tc('WEBAPP_COUNTRY_' + languageStore.country);
});

const backdropUrl = computed(() => {
	const posterUrl = props.title.content.backdrops[0]?.backdropUrl;
	if (!posterUrl) return '';
	return getImageUrl(posterUrl);
});

const watchNowOffer = computed(() => {
	return props.title.watchNowOffer;
});

function getImageUrl(posterUrl: string | undefined | null) {
	return Vue.filter('Thumbor')({
		url: posterUrl,
		imageType: 'backdrop',
		// FORCING THE HIGHEST QUALITY IMAGE FOR HERO BACKDROPS
		forceHighQuality: true,
		currentViewport: process.client ? undefined : Viewport.DESKTOP,
	} as ThumborOptions);
}

return { __sfc: true,props, tc, languageStore, countryName, backdropUrl, watchNowOffer, getImageUrl, WatchNowButton, BasicButton, PictureComp }
}

})